// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2jOzD","btnRed":"styles_btnRed__200Wz","wrap":"styles_wrap__1EOfS","spinner":"styles_spinner__3Kt6A","spinner-b87k6z":"styles_spinner-b87k6z__egene"};